<template>
  <div class="imgsetting">
    <div class="list">
      <van-cell >
        <div class="container">
          <div class="upload-button" @click="addbackground">
            <img src="/static/images/program/updata.png" alt="Upload" class="upload-icon">
          </div>
          <div class="scrollable-list">
            <div class="list-item" >
              <div class="delete-button" @click="dele()">
                <img src="/static/images/program/del.png">
              </div>
              <img v-if="pageBg!== '' ||bgImg !== ''" :src="pageBg?pageBg:bgImg"  @error="errImg($event)"  class="item-image">
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <addBackground  v-if="isBack" @setImages='setBackImage'  @close="close"/>
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";
import addBackground from "@/components/addBackground.vue";
import {Toast} from "vant";

export default {
  components: {addBackground},
  props: {
    pageBg: {
      type: String
    },
  },
  data(){
    return{
      isBack:false,
      bgImg:''
    }
  },
  mounted() {
    if(this.sceneList.scBackImg){
      const isHttpUrl =  this.sceneList.scBackImg.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=this.sceneList.scBackImg
      }else {
        this.bgImg=this.upFileUrl + this.sceneList.scBackImg
      }

    }
  },
  computed: {
    ...mapState({
      sceneList: state => state.sceneList,
    })
  },
  methods: {
    ...mapActions(['addBackground']),
    fullscreen() {
      this.$emit('fullscreen')
    },
    addbackground() {
      if(this.bgImg !='' || this.pageBg !=''){
        Toast(this.$t('append_field.oneImage'))
        return
      }
      this.isBack = true
    },
    dele() {
      this.$emit('ondele')
      this.bgImg=''
    },
    setBackImage(data) {
      this.isBack = false
      this.addBackground(data)
      const isHttpUrl =  data.url.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=data.url
      }else {
        this.bgImg=this.upFileUrl + data.url
      }
    },
    close() {
      this.isBack = false
    },
    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.imgsetting {
  /*border-top: 1px solid $uni-text-color-placeholder;*/

}


</style>
